// extracted by mini-css-extract-plugin
export var formContainer = "_je-0";
export var message = "_je-1";